import React from "react";
import {
  Mail,
  MapPin,
  MessageCircle
} from "lucide-react";

// reactstrap components
import {
  Container
} from "reactstrap";

// core components
import MainNavbar from "components/Navbars/MainNavbar.js";
import LandingPageHeader from "components/Headers/LandingPageHeader.js";
import DefaultFooter from "components/Footers/DefaultFooter.js";
import SEO from "components/SEO/SEO.js";

const emailAddress = "adriana@endgamedogs.com";
const facebookUrl = "https://www.facebook.com/endgamesportdogs";

function ContactPage() {
  React.useEffect(() => {
    document.body.classList.add("landing-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    return function cleanup() {
      document.body.classList.remove("landing-page");
      document.body.classList.remove("sidebar-collapse");
    };
  }, []);

  return (
    <>
      <SEO
        title="Contact"
        description="Contact Endgame Sport Dogs near Raleigh, North Carolina with questions about planned litters, sport dog puppies, border collies, and sport mixes."
        path="/contact"
      />
      <MainNavbar />
      <div className="wrapper contact-page site-bg-light-grey">
        <LandingPageHeader
          bg="header5"
          hideText
          title="Contact Endgame Sport Dogs"
          subtitle="Reach out about planned litters, puppy inquiries, or questions about the program."
        />
        <main className="contact-main site-bg-light-grey">
          <section className="contact-section">
            <Container>
              <div className="contact-page-heading">
                <h2>Start the conversation</h2>
                <span aria-hidden="true"></span>
              </div>

              <aside className="contact-info-panel contact-info-panel-centered">
                <p className="contact-eyebrow">Best ways to reach us</p>
                <h2>Facebook is usually fastest.</h2>
                <p>
                  Emails occasionally land in spam, so Facebook is preferred for initial contact. Email is ok for those who do not have Facebook.
                </p>

                <div className="contact-methods">
                  <a href={facebookUrl} className="contact-method">
                    <MessageCircle aria-hidden="true" size={24} strokeWidth={2} />
                    <span>
                      <strong>Facebook</strong>
                      Endgame Sport Dogs
                    </span>
                  </a>

                  <a href={`mailto:${emailAddress}`} className="contact-method">
                    <Mail aria-hidden="true" size={24} strokeWidth={2} />
                    <span>
                      <strong>Email</strong>
                      {emailAddress}
                    </span>
                  </a>

                  <div className="contact-method">
                    <MapPin aria-hidden="true" size={24} strokeWidth={2} />
                    <span>
                      <strong>Location</strong>
                      Near Raleigh, North Carolina
                    </span>
                  </div>
                </div>
              </aside>
            </Container>
          </section>
        </main>
        <DefaultFooter />
      </div>
    </>
  );
}

export default ContactPage;
